import { render, staticRenderFns } from "./UnAuthorised.vue?vue&type=template&id=2bb4ad72&scoped=true&"
import script from "./UnAuthorised.vue?vue&type=script&lang=js&"
export * from "./UnAuthorised.vue?vue&type=script&lang=js&"
import style0 from "./UnAuthorised.vue?vue&type=style&index=0&id=2bb4ad72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4ad72",
  null
  
)

export default component.exports